import React from "react";

import QRCode from "react-qr-code";

import { StoryQuestion } from "chq";
import { useIsMobile } from "app/hooks";
import { getSubdomain, Trans } from "app/utils";
import QRCodeBorder from "components/common/icons/QRCodeBorder";

import PostStoryModalButtonGetStart from "../principal-modal/PostStoryModalButtonGetStart";

type PostStoryLeftColumnProps = {
  onNextStep: () => void;
  prompt: StoryQuestion;
};

const PostStoryLeftColumn: React.FC<PostStoryLeftColumnProps> = ({ onNextStep, prompt }) => {
  const isMobile = useIsMobile();

  return (
    <div className="LeftColumn-ai col-xs-12 col-sm-6 col-lg-8">
      <div className="LeftColumn-ai__container">
        <div>
          <h2>{prompt.question}</h2>
          <p className="LeftColumn-ai__description">{prompt.summary}</p>
        </div>
        {!isMobile && (
          <div className="LeftColumn-ai__bottom-container">
            <PostStoryModalButtonGetStart onNextStep={onNextStep} />
            <div className="middle-text"><Trans>OR</Trans></div>
            <div className="QR-Container">
              <span className="QR-Container__Text"><Trans>Answer in mobile</Trans></span>
              <div className="QR-Container__Code">
                <QRCodeBorder />
                <QRCode
                  bgColor="transparent"
                  className="QR"
                  fgColor="#ffff"
                  size={120}
                  value={`https://${getSubdomain()}.culturehq.com/stories/trend/${prompt.id}`}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostStoryLeftColumn;
